import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SessionSettingsState {
  defaultDB: string | undefined;
}

const initialState: SessionSettingsState = {
  defaultDB: undefined,
};

const sessionSettingsSlice = createSlice({
  name: "sessionSettings",
  initialState: initialState,
  reducers: {
    setDefaultDB: (state, action: PayloadAction<string>) => {
      state.defaultDB = action.payload;
    },
  },
  extraReducers: undefined,
});

export const { setDefaultDB } = sessionSettingsSlice.actions;
export default sessionSettingsSlice.reducer;
